import { SapMasterProductsEdit } from "../../features"

const SapMasterProductsEditPage = () => {
  return <SapMasterProductsEdit />
}

export default SapMasterProductsEditPage
